import React from 'react';
import PropTypes from 'prop-types';
import { SEARCH_QUICKBOOKING_TIMING_DOCTORS } from '../queries';
import { Query } from 'react-apollo';
import Select from 'react-select';
import moment from 'moment';
import { logAmplitudeEvent } from '../utilities';

const DoctorSelector = props => {
  const {
    onChange,
    value,
    hospitalIds,
    departmentIds,
    cityId,
    specialty,
    placeholder,
    showAllDoctorOption,
    timings,
    dateSelected,
    isInPersonConsultation,
    procedures,
    showWalkIn
  } = props;

  const eventProps = {
    departmentIds,
    hospitalIds,
    cityId,
    timings,
    dateSelected,
    procedures
  };
  logAmplitudeEvent('Quick_Book_Doctor_Select', eventProps, true);

  const hasTimings = timings && timings.length > 0;
  const hasDate = dateSelected && dateSelected.length > 0;

  let startDate, endDate;

  if (hasDate) {
    if (hasTimings) {
      startDate = moment(
        `${dateSelected[0]} ${timings[0]}`,
        'DD/MM/YYYY HH:mm'
      ).toISOString();
      endDate = moment(`${dateSelected[0]} ${timings[0]}`, 'DD/MM/YYYY HH:mm')
        .add(1, 'hour')
        .toISOString();
    } else {
      startDate = moment(dateSelected[0], 'DD/MM/YYYY')
        .startOf('day')
        .toISOString();
      endDate = moment(dateSelected[0], 'DD/MM/YYYY')
        .endOf('day')
        .toISOString();
    }
  }

  return (
    <Query
      query={SEARCH_QUICKBOOKING_TIMING_DOCTORS}
      variables={{
        searchInput: {
          departmentIds,
          hospitalIds,
          procedures,
          cityId,
          specialty,
          startDate,
          endDate,
          isInPersonConsultation,
          showWalkIn,
          sortBy: 'Rank'
        }
      }}
      fetchPolicy="network-only"
      onCompleted={data => {
        if (props.onDoctorsFetched) {
          props.onDoctorsFetched(
            data && data.getDoctorsQuickBook ? data.getDoctorsQuickBook : []
          );
        }
      }}
    >
      {({ loading, data: { getDoctorsQuickBook = [] } = {} }) => {
        let options = [];
        if (getDoctorsQuickBook && getDoctorsQuickBook.length) {
          options = getDoctorsQuickBook.map(d => {
            return { label: `${d.name} (${d.primarySpecialty})`, value: d };
          });
          if (showAllDoctorOption) {
            options = [{ label: 'All', value: 'All' }].concat(options);
          }
        }
        return (
          <Select
            // isMulti={isMulti}
            value={value}
            options={options}
            isLoading={loading}
            onChange={onChange}
            placeholder={placeholder}
          />
        );
      }}
    </Query>
  );
};

DoctorSelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  hospitalIds: PropTypes.number,
  departmentIds: PropTypes.number,
  cityId: PropTypes.number,
  placeholder: PropTypes.string,
  showAllDoctorOption: PropTypes.bool,
  timings: PropTypes.string,
  dateSelected: PropTypes.string,
  specialty: PropTypes.string,
  isInPersonConsultation: PropTypes.bool,
  procedures: PropTypes.array,
  onDoctorsFetched: PropTypes.func,
  showWalkIn: PropTypes.bool
};

DoctorSelector.defaultProps = {
  showAllDoctorOption: false,
  isInPersonConsultation: false,
  procedures: [],
  showWalkIn: false
};

export default DoctorSelector;
